import "@mdi/font/css/materialdesignicons.css"
//import "vuetify/lib/styles/main.sass"
import { createVuetify } from 'vuetify'

export default createVuetify({
    theme: { defaultTheme: 'light' }
})